module.exports = __webpack_public_path__ + "img/lensman.87c33b58.jpg";